import RulesPageDefault from "../../../../components/Rules/RulesPageDefault";

export default function() {
    return (
        <div>
            <RulesPageDefault title="E. Game Master Guidelines"/>
        </div>
    )
}